import {Inject, Injectable} from '@angular/core';
import {DOCUMENT} from '@angular/common';
import {Observable, Observer, Subscription} from 'rxjs';
import {Router, NavigationStart, Event as NavigationEvent} from '@angular/router';
import {WindowRef} from '../../../shared/services/window.service';

// TODO find a better way to import these libs here
import SockJS = require('sockjs-client');
import Stomp = require('webstomp-client');

@Injectable()
export class UnitpriceService {

  stompClient = null;
  subscriber = null;
  connection:Promise<any>;
  connectedPromise:any;
  listener:Observable<any>;
  listenerObserver:Observer<any>;
  alreadyConnectedOnce:boolean = false;
  private subscription:Subscription;

  constructor(@Inject(DOCUMENT) private document:any,
              public $window:WindowRef,
              public router:Router
              //private csrfService: CSRFService
  ) {
    this.connection = this.createConnection();
    this.listener = this.createListener();
  }

  connect(type, lan , searchString) {
    if (this.connection === null) {
      this.connection = this.createConnection();
    }
    // building absolute path so that websocket doesnt fail when deploying with a context path
    const loc = window.location;
    let url = '//' + loc.host + loc.pathname + 'unitPrice';

    const socket = new SockJS(url);
    this.stompClient = Stomp.over(socket);
    let headers = {};
    //headers['X-XSRF-TOKEN'] = this.csrfService.getCSRF('XSRF-TOKEN');
    this.stompClient.connect(headers, () => {
      this.connectedPromise('success');
      if(type!=null&&lan!=null){
        this.sendRequest(type, null, null, lan,searchString);
      }
      if (!this.alreadyConnectedOnce) {
        this.router.events.forEach((event:NavigationEvent) => {
          if (event instanceof NavigationStart) {
            if (this.router.url === '/unitprice') {
              this.unsubscribe();
              this.disconnect();
            }

          }
        });
      }
      this.alreadyConnectedOnce = true;
    });
  }

  disconnect() {
    if (this.stompClient !== null) {
      this.stompClient.disconnect();
      this.stompClient = null;
    }
    this.connection = null;
  }

  receive() {
    return this.listener;
  }

  send1WeekRequest(lang,searchString) {
    this.sendRequest('1WEEK', null, null, lang,searchString);
  }

  send1MonthRequest(lang,searchString) {
    this.sendRequest('1MONTH', null, null, lang,searchString);
  }

  send3MonthsRequest(lang,searchString) {
    this.sendRequest('3MONTHS', null, null, lang,searchString);
  }

  send6MonthsRequest(lang,searchString) {
    this.sendRequest('6MONTHS', null, null, lang,searchString);
  }

  send1YearRequest(lang,searchString) {
    this.sendRequest('1YEAR', null, null, lang,searchString);
  }

  sendRequest(type, sdate, edate, lan,searchString) {
    if (this.stompClient !== null && this.stompClient.connected) {
      this.stompClient.send(
        '/topic/request/unitprice', // destination
        JSON.stringify({
          type: type,
          startDate: sdate,
          endDate: edate,
          lang: lan,
          searchString:searchString
        }), // body
        {} // header
      );
    }
  }

  subscribe() {
    this.connection.then(() => {
      this.subscriber = this.stompClient.subscribe('/user/queue/response/unitprice', data => {
        this.listenerObserver.next(JSON.parse(data.body));
      });
    });
  }

  unsubscribe() {
    if (this.subscriber !== null) {
      this.subscriber.unsubscribe();
    }
    this.listener = this.createListener();
  }

  private createListener():Observable<any> {
    return new Observable(observer => {
      this.listenerObserver = observer;
    });
  }

  private createConnection():Promise<any> {
    return new Promise((resolve, reject) => this.connectedPromise = resolve);
  }

}
